<app-side-nav></app-side-nav>
<div class="p-4 max-w-xl mx-auto pb-[7rem]">
  <!-- HEADER EN 1 LIGNE AVEC COLONNES GAUCHE & DROITE -->
  <div class="rounded-2xl p-4 border shadow-md transition-all hover:border-indigo-400/20 backdrop-blur-md mb-4"
       [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10' : 'bg-white border-indigo-500/10'" [ngStyle]="{ 'backdrop-filter': isDarkMode() ? 'blur(12px)' : 'none' }">

    <!-- 🔹 Ligne Logo + Wallet -->
    <div class="flex justify-between items-center gap-4 mb-3">
      <div class="flex items-center gap-2">
        <svg class="w-6 h-6 text-purple-500 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <h1 class="text-base font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-600 dark:from-indigo-400 dark:to-purple-300">
          Swap Tokens
        </h1>
      </div>

      <!-- 🔐 Wallet Badge -->
      <button class="flex items-center gap-1 px-3 py-1 rounded-full text-xs border shadow-sm backdrop-blur-md transition-all duration-300 font-medium"
              [ngClass]="takerAddress ? 'border-green-500 text-green-500 bg-green-100/20 dark:bg-green-400/10' : 'border-blue-400 text-blue-600 bg-blue-100/20 dark:bg-blue-400/10'"
              (click)="takerAddress ? disconnectWallet() : connectWallet()"
              [title]="takerAddress || 'Connect Wallet'">
        <svg *ngIf="!takerAddress" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path d="M21 8v8a3 3 0 01-3 3H6a3 3 0 01-3-3V8a3 3 0 013-3h12a3 3 0 013 3z" />
          <path d="M21 8H3m15 5h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2" />
        </svg>
        <svg *ngIf="takerAddress" class="w-4 h-4 animate-pulse text-green-400" fill="none" stroke="currentColor"
             viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        <span class="truncate max-w-[5rem]">{{ takerAddress ? getFormattedAddress(takerAddress) : '0xbb84…dcf5' }}</span>
      </button>
    </div>

    <div class="md:hidden flex justify-end">
      <button (click)="toggleTheme()"
              class="p-1 rounded-full transition
        shadow-none hover:shadow-none active:shadow-none
        focus:outline-none focus:ring-0 focus:shadow-none
        focus-visible:outline-none focus-visible:ring-0">
        <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5" fill="none" stroke="#a3bffa" stroke-width="2"
             viewBox="0 0 24 24">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
        <ng-template #lightIcon>
          <svg class="w-5 h-5" fill="none" stroke="#a3bffa" stroke-width="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
        </ng-template>
      </button>
    </div>
  </div>

  <!-- 🔄 Bloc Subscription Status + Tabs -->
  <div class="rounded-2xl p-4 border shadow-md transition-all backdrop-blur-md mb-4"
       [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10' : 'bg-white border-indigo-500/10'">


    <!-- 🟢 Statut : Alertes actives -->
    <div *ngIf="showActiveMessage"
         class="flex justify-end items-center overflow-hidden transition-all duration-700 ease-in-out mb-2 pr-1 opacity-100 max-h-12"
         [ngClass]="{ 'opacity-0 max-h-0': !showActiveMessage }">
      <span class="flex items-center gap-1 text-green-600 text-sm font-semibold transition-opacity duration-500">
        ✅ {{ 'ALERTS_ACTIVE' | translate }}
      </span>
    </div>


    <!-- 🕓 Statut : Vérification -->
    <div *ngIf="subscriptionStatus === 'pending'" class="w-full px-4 py-3 rounded-2xl shadow-md backdrop-blur-md border text-center
              bg-gradient-to-r from-purple-600 via-indigo-600 to-blue-600
              text-white text-sm font-semibold leading-snug"
         [ngClass]="isDarkMode()
         ? 'border-indigo-400/20'
         : 'border-indigo-500/10 shadow-xl'">
      🔓 Connectez votre wallet et optimisez vos swaps.
    </div>
    <!-- 🔒 Statut : Inactif -->
    <!-- 🔒 Subscription inactive – Call to Action Block -->
    <div *ngIf="subscriptionStatus === 'inactive'" class="max-w-xl mx-auto px-4">
      <div class="rounded-2xl border border-purple-400/30 bg-white/40 dark:bg-[#1e1e2f]/70 shadow-md dark:shadow-purple-900/10 backdrop-blur-md p-5 text-center transition-all duration-300">

        <!-- Titre incitatif -->
        <p class="text-sm font-semibold text-purple-800 dark:text-purple-100 leading-snug">
          🔔 {{ 'ACTIVATE_ALERTS_NOW' | translate }}
        </p>

        <!-- Texte explicatif -->
        <p class="text-xs text-gray-700 dark:text-gray-300 mt-1 leading-snug">
          {{ 'SUBSCRIPTION_DESCRIPTION_PART1' | translate }} <strong>2,99€/mois</strong>
          {{ 'SUBSCRIPTION_DESCRIPTION_PART2' | translate }} <strong>Swap Alert+</strong>.
          {{ 'CANCEL_ANYTIME' | translate }}
        </p>

        <!-- Bouton d’abonnement -->
        <button class="mt-4 w-full py-3 px-6 rounded-full text-sm font-bold text-white bg-gradient-to-r from-purple-500 to-indigo-600 hover:brightness-110 transition-all shadow-md"
                (click)="handleSubscriptionClick()">
          🔓 {{ 'ACTIVATE_SUBSCRIPTION' | translate }}
        </button>

        <!-- Avertissement wallet -->
        <p *ngIf="showWalletWarning"
           class="text-xs text-red-500 dark:text-red-300 mt-2 font-medium text-center">
          {{ 'CONNECT_WALLET_TO_SUBSCRIBE' | translate }}
        </p>
      </div>
    </div>


    <!-- 🔘 Sélecteur de type d’alerte -->
    <div class="flex justify-center gap-2 mt-4 flex-wrap">

      <button (click)="setTab('token')"
              [ngClass]="selectedTab === 'token'
              ? 'bg-gradient-to-r from-purple-500 to-indigo-600 text-white shadow-md'
              : 'bg-purple-100 text-purple-600 hover:bg-purple-200'"
              class="px-5 py-2 rounded-full text-sm font-semibold transition-all backdrop-blur-md">
        📈 {{ 'PRICE_OF_THE_TOKEN' | translate }}
      </button>

      <button (click)="setTab('gas')"
              [ngClass]="selectedTab === 'gas'
              ? 'bg-gradient-to-r from-purple-500 to-indigo-600 text-white shadow-md'
              : 'bg-purple-100 text-purple-600 hover:bg-purple-200'"
              class="px-5 py-2 rounded-full text-sm font-semibold transition-all backdrop-blur-md">
        ⛽ {{ 'PRICE_OF_THE_GAS' | translate }}
      </button>
    </div>
  </div>


  <!-- Créer une alerte (version ultra KISS) -->


  <div *ngIf="selectedTab === 'token'">
    <ng-container *ngIf="subscriptionStatus === 'active'; else mockSwapCard">
      <!-- Sell amount and token selection -->
      <!-- 🟣 Bloc Swap Card -->
      <div class="rounded-2xl p-4 border border-purple-500 shadow-md transition-all  backdrop-blur-md mb-4"
           [ngClass]="{
  'bg-white ': !isDarkMode(),
  'bg-[#1e1e2f]/70  dark:shadow-purple-900/10': isDarkMode()
}">


        <!-- Sell amount and token selection -->

        <label class="text-sm font-semibold tracking-wide"
               [ngClass]="isDarkMode()
  ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600'
  : 'text-[#7C3AED]'">
          {{ 'SELL_AMOUNT' | translate }}
        </label>
        <div class="relative mt-1">
          <input type="number"
                 class="w-full h-13 px-4 pr-24 rounded-xl border border-purple-400 focus:ring-2 focus:ring-purple-400 transition-all font-semibold text-lg
    bg-white dark:bg-gray-800 text-black placeholder-gray-400 dark:placeholder-gray-500"
                 [ngClass]="isDarkMode()
  ? 'bg-gray-800 placeholder-gray-500'
  : 'bg-white placeholder-gray-400'"
                 [(ngModel)]="alert.amountIn"
                 placeholder="0.0"
                 (ngModelChange)="onAmountChanged()" />

        </div>
        <div class="flex-1 relative mt-4" (clickOutside)="showSellDropdown = false">
          <!-- Trigger -->
          <button type="button"
                  (click)="showTokenModal = true"
                  class="w-full flex items-center justify-between px-4 py-3 mt-1 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 transition shadow-sm">


            <div class="flex items-center gap-2">
              <img [src]="getTokenLogo(alert.tokenIn)" class="w-6 h-6 rounded-full" />
              <span class="font-bold text-black dark:text-white">{{ getTokenLabel(alert.tokenIn) }}</span>
            </div>

            <span class="text-xs text-black">
              {{ alert.tokenIn ? (getTokenBalance(alert.tokenIn) || '') : '' }}
            </span>

          </button>

          <!-- Dropdown list -->
          <ul *ngIf="showSellDropdown"
              class="mt-2 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-black dark:text-black max-h-60 overflow-y-auto z-10">
            <li *ngFor="let token of filteredSellTokens"
                (click)="onSellTokenClick($event, token.symbol)"
                class="px-4 py-3 cursor-pointer hover:bg-purple-100 dark:hover:bg-purple-900 transition-colors text-sm">


              <div class="flex flex-col gap-0.5">
                <div>
                  <div class="flex items-center gap-2 font-medium">
                    <img [src]="getTokenLogo(token.symbol)"
                         [alt]="token.symbol"
                         class="w-5 h-5 rounded-full" />
                    {{ getTokenLabel(token.symbol) }} – {{ token.name }}
                  </div>
                </div>
                <div class="text-xs text-green-500 text-right">
                  {{ getTokenBalance(token.symbol) || '' }}
                </div>
              </div>

            </li>
          </ul>
        </div>
        <br />
        <!-- Buy token selection -->
        <div class="col-span-2 relative" (clickOutside)="showBuyDropdown = false">
          <!-- Label -->
          <label class="text-sm font-semibold tracking-wide"
                 [ngClass]="isDarkMode()
  ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600'
  : 'text-[#7C3AED]'">
            {{ 'BUY_TOKEN' | translate }}
          </label>

          <!-- Trigger / pseudo‑input -->
          <button type="button"
                  (click)="showBuyTokenModal = true"
                  class="w-full flex items-center mt-1 justify-between  px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:shadow-purple-900/10 transition shadow-sm">

            <div class="flex items-center gap-2">
              <!-- Icône du token -->
              <img [src]="getTokenLogo(alert.tokenOut)"
                   [alt]="alert.tokenOut"
                   class="w-6 h-6 rounded-full shrink-0" />

              <!-- Symbole du token -->
              <span class="text-sm font-bold text-black">
                {{ getTokenLabel(alert.tokenOut) }}
              </span>
            </div>
          </button>

          <!-- DROPDOWN LIST -->
          <ul *ngIf="showBuyDropdown"
              class="mt-2 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-black dark:text-black max-h-60 overflow-y-auto z-10">
            <li *ngFor="let token of filteredBuyTokens"
                (click)="onBuyTokenClick($event, token.symbol)"
                class="px-4 py-3 hover:bg-purple-100 dark:hover:bg-purple-900 cursor-pointer transition text-sm text-black dark:text-black">
              <div class="flex items-center gap-2">
                <img [src]="getTokenLogo(token.symbol)"
                     [alt]="token.symbol"
                     class="w-5 h-5 rounded-full" />
                {{ getTokenLabel(token.symbol) }} – {{ token.name }}
              </div>
            </li>
          </ul>

        </div>
        <br />

      </div>

    </ng-container>

    <!-- 🔒 VERSION MOCKÉE -->
    <ng-template #mockSwapCard>
      <!-- 🟣 Bloc Swap Card mocké (readonly / vitrine) -->
      <div class="rounded-2xl p-4 border border-purple-500 shadow-md transition-all  backdrop-blur-md mb-4"
           [ngClass]="{
  'bg-white ': !isDarkMode(),
  'bg-[#1e1e2f]/70  dark:shadow-purple-900/10': isDarkMode()
}">
        <!-- ✅ Badge [Données d'exemple] en haut à droite – version pro -->
        <!-- ✅ Badge Warning élégant -->
        <div class="flex justify-end mb-2">
          <span class="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide
           text-orange-800 dark:text-orange-300 px-3 py-1 rounded-full
           bg-orange-100 dark:bg-orange-900/30 border border-orange-300 dark:border-orange-600
           shadow-sm shadow-orange-200/40 dark:shadow-orange-900/10 backdrop-blur-sm">

            Données d’exemple
          </span>
        </div>


        <!-- VENDRE -->
        <label class="text-sm font-semibold tracking-wide"
               [ngClass]="isDarkMode()
  ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600'
  : 'text-[#7C3AED]'">
          {{ 'SELL_AMOUNT' | translate }}
        </label>
        <div class="flex items-center justify-between mt-1 px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800">
          <div class="flex items-center gap-2">
            <span class="font-bold text-black dark:text-white">{{ currentMockAlert.amountIn }}</span>
          </div>

        </div>
        <!-- TOKEN IN -->
        <div class="flex items-center justify-between mt-4 px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800">
          <div class="flex items-center gap-2">
            <img [src]="getTokenLogo(currentMockAlert.tokenIn)" class="w-6 h-6 rounded-full" />
            <span class="font-bold text-black dark:text-white">{{ getTokenLabel(currentMockAlert.tokenIn) }}</span>
          </div>
          <span class="text-xs text-gray-500 dark:text-gray-400">
            10
          </span>
        </div>

        <!-- TOKEN OUT -->
        <div class="mt-6">
          <label class="text-sm font-semibold tracking-wide mt-8"
                 [ngClass]="isDarkMode()
  ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600'
  : 'text-[#7C3AED]'">
            {{ 'BUY_TOKEN' | translate }}
          </label>
        </div>
        <div class="flex items-center justify-between px-4 py-3 rounded-xl border border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800">
          <div class="flex items-center gap-2">
            <img [src]="getTokenLogo(currentMockAlert.tokenOut)" class="w-6 h-6 rounded-full" />
            <span class="font-bold text-black dark:text-white">{{ getTokenLabel(currentMockAlert.tokenOut) }}</span>
          </div>
        </div>

      </div>
    </ng-template>
    <ng-container *ngIf="subscriptionStatus === 'active'; else mockThresholdBlock">
      <div class="rounded-2xl border shadow-md backdrop-blur-md mb-3 transition-all"
           [ngClass]="[
       isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10' : 'bg-white border-indigo-500/10',
       isOpen ? 'p-4' : 'p-3'
     ]">

        <!-- Header cliquable + bouton Remove -->
        <div class="flex gap-3 mb-2" [ngClass]="isOpen ? 'items-center' : 'items-start'">
          <!-- Zone cliquable (chevron + titre + résumé compact seulement quand c’est plié) -->
          <button type="button"
                  class="group flex-1 -mx-2 px-2 rounded-xl text-left hover:bg-purple-50/40 dark:hover:bg-white/5 transition-colors"
                  (click)="toggleOpen()" (keydown)="onHeaderKey($event)"
                  [attr.aria-expanded]="isOpen" [attr.aria-controls]="'alert-collapse-'+(alert?.id ?? 'x')" tabindex="0"
                  [ngClass]="isOpen ? 'py-1' : 'py-0'">

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-purple-500 transition-transform"
                     [ngClass]="{ 'rotate-90': isOpen }" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M6 4l8 6-8 6V4z" clip-rule="evenodd"></path>
                </svg>
                <span class="text-sm font-semibold text-[#7C3AED] dark:text-purple-300">
                  {{ 'AT_LEAST' | translate }}
                </span>
              </div>

              <!-- Résumé compact → visible UNIQUEMENT quand c’est plié -->
              <div *ngIf="!isOpen" class="flex items-center gap-2 text-xs">
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border text-gray-700 dark:text-gray-200">
                  ≥ {{ formatAmount(alert.threshold) }} {{ getTokenLabel(alert.tokenOut) }}
                </span>
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border border-purple-300/60
                     text-purple-600 font-semibold">
                  + {{ percentageExpected?.toFixed(1) }} %
                </span>
              </div>
            </div>

            <!-- Hint compact (seulement fermé) -->
            <div *ngIf="!isOpen" class="mt-1 text-[11px] text-gray-400">
              {{ 'TAP_TO_EDIT' | translate : { default: 'Cliquer pour modifier' } }}
            </div>
          </button>

          <!-- REMOVE : centré en ouvert, top-align en fermé -->
          <button (click)="showTokenThresholdInput = false; showMarketViewer = false"
                  class="shrink-0 inline-flex items-center justify-center rounded-lg
           border border-purple-300/40 hover:border-purple-400/70
           text-xs px-3 leading-none select-none"
                  [ngClass]="isOpen ? 'h-7 self-center' : 'h-6 self-start mt-[1px]'">
            − {{ 'REMOVE' | translate }}
          </button>
        </div>




        <!-- Zone dépliée -->
        <div [attr.id]="'alert-collapse-'+(alert?.id ?? 'x')" *ngIf="isOpen">
          <!-- Inputs -->
          <!-- Inputs alignés au bord droit -->
          <div class="grid w-full justify-end gap-3
         grid-cols-[minmax(12rem,1fr),6rem]
         sm:grid-cols-[minmax(14rem,24rem),6.5rem]
         md:grid-cols-[minmax(16rem,28rem),6.5rem]">

            <!-- Amount + chip -->
            <div class="relative h-12 w-full">
              <input type="number" inputmode="decimal"
                     class="absolute inset-0 w-full h-full pl-4 pr-[72px] rounded-xl
           border border-gray-300 dark:border-gray-600
           bg-white dark:bg-gray-800 text-base font-semibold
           text-left tabular-nums leading-none focus:ring-2 focus:ring-purple-400
           [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                     [value]="formatAmount(alert.threshold)"
                     (input)="onFormattedThresholdInput($event)"
                     placeholder="0.00" />

              <span class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2
               h-8 px-2 rounded-md text-xs font-bold flex items-center justify-center
               bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300
               border border-gray-200/70 dark:border-gray-600/60">
                {{ getTokenLabel(alert.tokenOut) }}
              </span>
            </div>


            <!-- % + nudges (compact) -->
            <div class="flex flex-col items-stretch w-full">
              <div class="relative">
                <input type="number" step="0.5"
                       class="w-full h-10 pl-5 pr-5 text-right rounded-xl border border-purple-300/60
                    bg-white dark:bg-gray-800 text-base font-extrabold text-purple-600
                    focus:ring-2 focus:ring-purple-400"
                       [value]="percentageExpected?.toFixed(1)" placeholder="0"
                       (input)="onPercentageInput($event)" />
                <span class="pointer-events-none absolute left-1.5 inset-y-0 flex items-center
                 text-purple-400 font-bold text-base">+</span>
                <span class="pointer-events-none absolute right-1.5 inset-y-0 flex items-center
                 text-purple-400 font-bold text-base">%</span>
              </div>

              <div class="mt-1 flex justify-center gap-2 text-purple-500">
                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="nudgePercentage(-0.5)">
                  −0.5
                </button>

                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="nudgePercentage(+0.5)">
                  +0.5
                </button>
              </div>
            </div>
          </div>


          <!-- MarketViewer auto -->
          <div class="mt-3 p-3 rounded-xl border border-purple-300/50 bg-purple-50/20 dark:bg-white/5">
            <app-swap-market-viewer [tokenIn]="alert.tokenIn ?? null"
                                    [tokenOut]="alert.tokenOut ?? null"
                                    [amountIn]="alert.amountIn ?? null"
                                    [amountOut]="alert.liveQuote ?? null"
                                    [isLoading]="isTrendLoading"
                                    [hasData]="hasMarketTrendData"
                                    [marketTrendData]="marketTrendData"
                                    (trendClicked)="onTrendSelected($event)">
            </app-swap-market-viewer>
          </div>

          <!-- Live preview -->
          <div *ngIf="quotePreview" class="mt-3 text-xs text-green-600 font-medium">
            ✔ {{ 'NOW_YOU_RECEIVE' | translate }}
            <strong>{{ quotePreview | number:'1.2-2' }} {{ getTokenLabel(alert.tokenOut) }}</strong>
            {{ 'FOR' | translate }} {{ alert.amountIn }} {{ getTokenLabel(alert.tokenIn) }}
          </div>

          <!-- Loading -->
          <div *ngIf="isQuoteLoading" class="mt-2 text-xs text-purple-500 animate-pulse">
            ⏳ {{ 'CALCULATING' | translate }}…
          </div>
        </div>
      </div>




    </ng-container>

    <!-- 🔒 VERSION MOCKÉE -->
    <ng-template #mockThresholdBlock>
      <div class="rounded-2xl border shadow-md backdrop-blur-md mb-3 transition-all"
           [ngClass]="[
       isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10' : 'bg-white border-indigo-500/10',
       isOpen ? 'p-4' : 'p-3'
     ]">

        <!-- Header cliquable + bouton Remove -->
        <div class="flex gap-3 mb-2" [ngClass]="isOpen ? 'items-center' : 'items-start'">
          <!-- Zone cliquable (chevron + titre + résumé compact seulement quand c’est plié) -->
          <button type="button"
                  class="group flex-1 -mx-2 px-2 rounded-xl text-left hover:bg-purple-50/40 dark:hover:bg-white/5 transition-colors"
                  (click)="toggleOpen()" (keydown)="onHeaderKey($event)"
                  [attr.aria-expanded]="isOpen" [attr.aria-controls]="'alert-collapse-'+(alert?.id ?? 'x')" tabindex="0"
                  [ngClass]="isOpen ? 'py-1' : 'py-0'">

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-purple-500 transition-transform"
                     [ngClass]="{ 'rotate-90': isOpen }" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M6 4l8 6-8 6V4z" clip-rule="evenodd"></path>
                </svg>
                <span class="text-sm font-semibold text-[#7C3AED] dark:text-purple-300">
                  {{ 'AT_LEAST' | translate }}
                </span>
              </div>

              
              <!-- Résumé compact → visible UNIQUEMENT quand c’est plié -->
              <div *ngIf="!isOpen" class="flex items-center gap-1 text-xs min-w-0 overflow-hidden">
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border text-gray-700 dark:text-gray-200
               flex-shrink min-w-0 truncate max-w-[45%] text-[10px] sm:text-xs">
                  ≥ {{ formatAmount(currentMockAlert.threshold) }} {{ getTokenLabel(currentMockAlert.tokenOut) }}
                </span>
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border border-purple-300/60
               text-purple-600 font-semibold flex-shrink min-w-0 truncate max-w-[45%] text-[10px] sm:text-xs">
                  + {{ percentageExpected?.toFixed(1) }} %
                </span>
              </div>

            </div>

            <!-- Hint compact (seulement fermé) -->
            <div *ngIf="!isOpen" class="mt-1 text-[11px] text-gray-400">
              {{ 'TAP_TO_EDIT' | translate : { default: 'Cliquer pour modifier' } }}
            </div>
          </button>

          <!-- REMOVE : centré en ouvert, top-align en fermé -->
          <button (click)="showTokenThresholdInput = false; showMarketViewer = false"
                  class="shrink-0 inline-flex items-center justify-center rounded-lg
           border border-purple-300/40 hover:border-purple-400/70
           text-xs px-3 leading-none select-none"
                  [ngClass]="isOpen ? 'h-7 self-center' : 'h-6 self-start mt-[1px]'">
            − {{ 'REMOVE' | translate }}
          </button>
        </div>




        <!-- Zone dépliée -->
        <div [attr.id]="'alert-collapse-'+(alert?.id ?? 'x')" *ngIf="isOpen">
          <!-- Inputs -->
          <!-- Inputs alignés au bord droit -->
          <div class="grid w-full justify-end gap-3
         grid-cols-[minmax(12rem,1fr),6rem]
         sm:grid-cols-[minmax(14rem,24rem),6.5rem]
         md:grid-cols-[minmax(16rem,28rem),6.5rem]">

            <!-- Amount + chip -->
            <div class="relative h-12 w-full">
              <input type="number" inputmode="decimal"
                     class="absolute inset-0 w-full h-full pl-4 pr-[72px] rounded-xl
           border border-gray-300 dark:border-gray-600
           bg-white dark:bg-gray-800 text-base font-semibold
           text-left tabular-nums leading-none focus:ring-2 focus:ring-purple-400
           [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                     [value]="formatAmount(currentMockAlert.threshold)"
                     (input)="onFormattedThresholdInput($event)"
                     placeholder="0.00" />

              <span class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2
               h-8 px-2 rounded-md text-xs font-bold flex items-center justify-center
               bg-gray-100 dark:bg-gray-700 text-black
               border border-gray-200/70 dark:border-gray-600/60">
                {{ getTokenLabel(currentMockAlert.tokenOut) }}
              </span>
            </div>


            <!-- % + nudges (compact) -->
            <div class="flex flex-col items-stretch w-full">
              <div class="relative">
                <input type="number" step="0.5"
                       class="w-full h-10 pl-5 pr-5 text-right rounded-xl border border-purple-300/60
                    bg-white dark:bg-gray-800 text-base font-extrabold text-purple-600
                    focus:ring-2 focus:ring-purple-400"
                       [value]="percentageExpected?.toFixed(1)" placeholder="0"
                       (input)="onPercentageInput($event)" />
                <span class="pointer-events-none absolute left-1.5 inset-y-0 flex items-center
                 text-purple-400 font-bold text-base">+</span>
                <span class="pointer-events-none absolute right-1.5 inset-y-0 flex items-center
                 text-purple-400 font-bold text-base">%</span>
              </div>

              <div class="mt-1 flex justify-center gap-2 text-purple-500">
                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="nudgePercentage(-0.5)">
                  −0.5
                </button>

                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="nudgePercentage(+0.5)">
                  +0.5
                </button>
              </div>
            </div>
          </div>


          <!-- MarketViewer auto -->
          <div class="mt-3 p-3 rounded-xl border border-purple-300/50 bg-purple-50/20 dark:bg-white/5">
            <app-swap-market-viewer [tokenIn]="'USDC'"
                                    [tokenOut]="'ETH'"
                                    [amountIn]="100"
                                    [amountOut]="0.058"
                                    [isLoading]="false"
                                    [hasData]="true"
                                    [marketTrendData]="{ amount: 100, trends: { '1h': -0.5, '6h': 2.3, '24h': 4.9 } }"
                                    (trendClicked)="null">
            </app-swap-market-viewer>
          </div>

          <!-- Live preview -->
          <div *ngIf="quotePreview" class="mt-3 text-xs text-green-600 font-medium">
            ✔ {{ 'NOW_YOU_RECEIVE' | translate }}
            <strong>{{ quotePreview | number:'1.2-2' }} {{ getTokenLabel(currentMockAlert.tokenOut) }}</strong>
            {{ 'FOR' | translate }} {{ currentMockAlert.amountIn }} {{ getTokenLabel(currentMockAlert.tokenIn) }}
          </div>

          <!-- Loading -->
          <div *ngIf="isQuoteLoading" class="mt-2 text-xs text-purple-500 animate-pulse">
            ⏳ {{ 'CALCULATING' | translate }}…
          </div>
        </div>
      </div>

    </ng-template>

    <!-- Sélecteur ET / OU -->
    <!-- 🔘 Selector logique ET / OU stylisé premium -->
    <div *ngIf="showGasFeeInput && showTokenThresholdInput" class="mx-auto w-fit mt-2 mb-3">
      <fieldset class="relative flex items-center gap-1.5 rounded-full border border-purple-300/40
           bg-white/80 dark:bg-[#1e1e2f]/80 shadow-inner px-1.5 py-1
           leading-none align-middle backdrop-blur"
                role="radiogroup"
                [attr.aria-label]="'LOGIC_MODE' | translate"
                [dir]="isArabicLang ? 'rtl' : 'ltr'">

        <!-- AND -->
        <label class="relative cursor-pointer select-none">
          <input type="radio"
                 class="peer sr-only"
                 [(ngModel)]="alert.conditionMode"
                 [name]="'logicMode_'+(alert?.id ?? 'x')"
                 [value]="'AND'">
          <span class="inline-flex h-9 min-w-[64px] items-center justify-center rounded-full px-4
               text-xs font-semibold tracking-wide transition-colors duration-200 ease-out
               text-purple-600 hover:bg-purple-50/70 dark:hover:bg-white/5
               peer-checked:text-white peer-checked:bg-gradient-to-r
               peer-checked:from-purple-500 peer-checked:to-indigo-600
               peer-checked:shadow-md">
            <span [ngClass]="isArabicLang ? 'text-base font-extrabold tracking-wide' : ''">
              {{ 'AND' | translate }}
            </span>
          </span>
          <!-- focus ring accessible -->
          <span class="pointer-events-none absolute inset-0 rounded-full ring-2 ring-transparent
                   peer-focus-visible:ring-purple-400 ring-offset-2
                   ring-offset-white dark:ring-offset-[#1e1e2f]"></span>
        </label>

        <!-- OR -->
        <label class="relative cursor-pointer select-none">
          <input type="radio"
                 class="peer sr-only"
                 [(ngModel)]="alert.conditionMode"
                 [name]="'logicMode_'+(alert?.id ?? 'x')"
                 [value]="'OR'">
          <span class="inline-flex h-9 min-w-[64px] items-center justify-center rounded-full px-4
               text-xs font-semibold tracking-wide transition-colors duration-200 ease-out
               text-purple-600 hover:bg-purple-50/70 dark:hover:bg-white/5
               peer-checked:text-white peer-checked:bg-gradient-to-r
               peer-checked:from-purple-500 peer-checked:to-indigo-600
               peer-checked:shadow-md">
            <span [ngClass]="isArabicLang ? 'text-base font-extrabold tracking-wide' : ''">
              {{ 'OR' | translate }}
            </span>
          </span>
          <span class="pointer-events-none absolute inset-0 rounded-full ring-2 ring-transparent
                   peer-focus-visible:ring-purple-400 ring-offset-2
                   ring-offset-white dark:ring-offset-[#1e1e2f]"></span>
        </label>

      </fieldset>
    </div>



    <!-- ✅ VERSION DYNAMIQUE SI ABONNÉ -->
    <ng-container *ngIf="subscriptionStatus === 'active'; else mockGasBlock">
      <div class="relative rounded-2xl border shadow-md backdrop-blur-md transition-all overflow-visible"
           [ngClass]="[
         isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10' : 'bg-white border-indigo-500/10',
         isGasOpen ? 'p-4' : 'p-3',
         'mb-4'
       ]">

        <!-- Header cliquable + Remove -->
        <div class="flex gap-3 mb-2" [ngClass]="isGasOpen ? 'items-center' : 'items-start'">
          <button type="button"
                  class="group flex-1 -mx-2 px-2 rounded-xl text-left hover:bg-purple-50/40 dark:hover:bg-white/5 transition-colors"
                  (click)="toggleGasOpen()" (keydown)="onGasHeaderKey($event)"
                  [attr.aria-expanded]="isGasOpen" [attr.aria-controls]="'gas-collapse-'+(alert?.id ?? 'x')" tabindex="0"
                  [ngClass]="isGasOpen ? 'py-1' : 'py-0'">

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-purple-500 transition-transform"
                     [ngClass]="{ 'rotate-90': isGasOpen }" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M6 4l8 6-8 6V4z" clip-rule="evenodd"></path>
                </svg>
                <span class="text-sm font-semibold text-[#7C3AED] dark:text-purple-300">
                  {{ 'GAS_PRICE_UNDER' | translate }}
                </span>
              </div>

              <!-- résumé compact visible UNIQUEMENT quand c’est plié -->
              <div *ngIf="!isGasOpen" class="flex items-center gap-2 text-xs">
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border text-gray-700 dark:text-gray-200">
                  ≤ {{ displayedGas | number:'1.0-5' }} Gwei
                </span>
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border border-purple-300/60
                         text-purple-600 font-semibold">
                  − {{ (_gasTrendPercentModel ?? 0) | number:'1.1-1' }} %
                </span>
              </div>
            </div>

            <div *ngIf="!isGasOpen" class="mt-1 text-[11px] text-gray-400">
              {{ 'TAP_TO_EDIT' | translate : { default: 'Cliquer pour modifier' } }}
            </div>
          </button>

          <!-- REMOVE aligné -->
          <button (click)="showGasFeeInput = false; showGasTrendViewer = false"
                  class="shrink-0 inline-flex items-center justify-center rounded-lg
                     border border-purple-300/40 hover:border-purple-400/70
                     text-xs px-3 leading-none select-none"
                  [ngClass]="isGasOpen ? 'h-7 self-center' : 'h-6 self-start mt-[1px]'">
            − {{ 'REMOVE' | translate }}
          </button>
        </div>

        <!-- Zone dépliée -->
        <div [attr.id]="'gas-collapse-'+(alert?.id ?? 'x')" *ngIf="isGasOpen">
          <!-- Inputs alignés au bord droit -->
          <div class="grid w-full justify-end gap-3
                  grid-cols-[minmax(12rem,1fr),6rem]
                  sm:grid-cols-[minmax(14rem,24rem),6.5rem]
                  md:grid-cols-[minmax(16rem,28rem),6.5rem]">

            <!-- Gas value + chip Gwei -->
            <div class="relative h-12 w-full">
              <input type="number" inputmode="decimal"
                     class="absolute inset-0 w-full h-full pl-4 pr-[64px] rounded-xl
                        border border-gray-300 dark:border-gray-600
                        bg-white dark:bg-gray-800 text-base font-semibold
                        text-left tabular-nums leading-none focus:ring-2 focus:ring-purple-400
                        [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                     [ngModel]="displayedGas"
                     (ngModelChange)="onDisplayedGasChange($event)"
                     placeholder="0.00" />
              <span class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2
                       h-8 px-2 rounded-md text-xs font-bold flex items-center justify-center
                       bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300
                       border border-gray-200/70 dark:border-gray-600/60">
                Gwei
              </span>
            </div>

            <!-- % (compact) + nudges -->
            <div class="flex flex-col items-stretch w-full">
              <div class="relative">
                <input type="number" step="0.5"
                       class="w-full h-10 pl-5 pr-5 text-right rounded-xl border border-purple-300/60
                          bg-white dark:bg-gray-800 text-base font-extrabold text-purple-600
                          focus:ring-2 focus:ring-purple-400"
                       [ngModel]="_gasTrendPercentModel"
                       (ngModelChange)="gasTrendPercent = $event" placeholder="0" />
                <span class="pointer-events-none absolute left-1.5 inset-y-0 flex items-center
                         text-purple-400 font-bold text-base">−</span>
                <span class="pointer-events-none absolute right-1.5 inset-y-0 flex items-center
                         text-purple-400 font-bold text-base">%</span>
              </div>

              <div class="mt-1 flex justify-center gap-2 text-purple-500">
                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                           rounded-md border border-purple-300/60 hover:bg-purple-50
                           text-[11px] font-medium"
                        (click)="_gasTrendPercentModel = (_gasTrendPercentModel ?? 0) - 0.5; gasTrendPercent = _gasTrendPercentModel">
                  −0.5
                </button>

                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                           rounded-md border border-purple-300/60 hover:bg-purple-50
                           text-[11px] font-medium"
                        (click)="_gasTrendPercentModel = (_gasTrendPercentModel ?? 0) + 0.5; gasTrendPercent = _gasTrendPercentModel">
                  +0.5
                </button>
              </div>
            </div>
          </div>

          <!-- Trend viewer auto (plus de "VIEW_TRENDS") -->
          <div class="mt-3 p-3 rounded-xl border border-purple-300/50 bg-purple-50/20 dark:bg-white/5">
            <app-swap-gas-trend-viewer [gasTrendData]="gasTrendData"
                                       [isLoading]="isGasTrendLoading"
                                       [hasData]="hasGasTrendData"
                                       (applyPercentage)="onGasTrendSelected($event)">
            </app-swap-gas-trend-viewer>
          </div>

          <!-- Live preview -->
          <div *ngIf="currentGasGwei" class="mt-3 text-xs text-green-600 font-medium">
            ✔ {{ 'CURRENT_PRICE' | translate }}: <strong>{{ currentGasGwei }} Gwei</strong>
          </div>
        </div>
      </div>
    </ng-container>


    <!-- 🔒 VERSION MOCKÉE SI NON ABONNÉ -->
    <ng-template #mockGasBlock>
      <div class="relative rounded-2xl border shadow-md backdrop-blur-md transition-all overflow-visible"
           [ngClass]="[
   isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10' : 'bg-white border-indigo-500/10',
   isGasOpen ? 'p-4' : 'p-3',
   'mb-4'
 ]">

        <!-- Header cliquable + Remove -->
        <div class="flex gap-3 mb-2" [ngClass]="isGasOpen ? 'items-center' : 'items-start'">
          <button type="button"
                  class="group flex-1 -mx-2 px-2 rounded-xl text-left hover:bg-purple-50/40 dark:hover:bg-white/5 transition-colors"
                  (click)="toggleGasOpen()" (keydown)="onGasHeaderKey($event)"
                  [attr.aria-expanded]="isGasOpen" [attr.aria-controls]="'gas-collapse-'+(alert?.id ?? 'x')" tabindex="0"
                  [ngClass]="isGasOpen ? 'py-1' : 'py-0'">

            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-purple-500 transition-transform"
                     [ngClass]="{ 'rotate-90': isGasOpen }" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M6 4l8 6-8 6V4z" clip-rule="evenodd"></path>
                </svg>
                <span class="text-sm font-semibold text-[#7C3AED] dark:text-purple-300">
                  {{ 'GAS_PRICE_UNDER' | translate }}
                </span>
              </div>


              <!-- Résumé compact → visible UNIQUEMENT quand c’est plié -->
              <div *ngIf="!isOpen" class="flex items-center gap-1 text-xs min-w-0 overflow-hidden">
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border text-gray-700 dark:text-gray-200
               flex-shrink min-w-0 truncate max-w-[45%] text-[10px] sm:text-xs">
                  ≤ {{ (currentMockAlert.maxGasFee ?? 0) / 1e9 | number:'1.0-5' }} Gwei
                </span>
                <span class="inline-flex items-center h-6 leading-6 px-2 rounded-md border border-purple-300/60
               text-purple-600 font-semibold flex-shrink min-w-0 truncate max-w-[45%] text-[10px] sm:text-xs">
                  − {{ (_gasTrendPercentModel ?? 0) | number:'1.1-1' }} %
                </span>
              </div>

            </div>

            <div *ngIf="!isGasOpen" class="mt-1 text-[11px] text-gray-400">
              {{ 'TAP_TO_EDIT' | translate : { default: 'Cliquer pour modifier' } }}
            </div>
          </button>

          <!-- REMOVE aligné -->
          <button (click)="showGasFeeInput = false; showGasTrendViewer = false"
                  class="shrink-0 inline-flex items-center justify-center rounded-lg
               border border-purple-300/40 hover:border-purple-400/70
               text-xs px-3 leading-none select-none"
                  [ngClass]="isGasOpen ? 'h-7 self-center' : 'h-6 self-start mt-[1px]'">
            − {{ 'REMOVE' | translate }}
          </button>
        </div>

        <!-- Zone dépliée -->
        <div [attr.id]="'gas-collapse-'+(alert?.id ?? 'x')" *ngIf="isGasOpen">
          <!-- Inputs alignés au bord droit -->
          <div class="grid w-full justify-end gap-3
            grid-cols-[minmax(12rem,1fr),6rem]
            sm:grid-cols-[minmax(14rem,24rem),6.5rem]
            md:grid-cols-[minmax(16rem,28rem),6.5rem]">

            <!-- Gas value + chip Gwei -->
            <div class="relative h-12 w-full">
              <input type="number" inputmode="decimal"
                     class="absolute inset-0 w-full h-full pl-4 pr-[64px] rounded-xl
                  border border-gray-300 dark:border-gray-600
                  bg-white dark:bg-gray-800 text-base font-semibold
                  text-left tabular-nums leading-none focus:ring-2 focus:ring-purple-400
                  [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                     [ngModel]="displayedGas"
                     value="currentMockAlert.maxGasFee"
                     placeholder="0.00" />
              <span class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2
                 h-8 px-2 rounded-md text-xs font-bold flex items-center justify-center
                 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300
                 border border-gray-200/70 dark:border-gray-600/60">
                Gwei
              </span>
            </div>

            <!-- % (compact) + nudges -->
            <div class="flex flex-col items-stretch w-full">
              <div class="relative">
                <input type="number" step="0.5"
                       class="w-full h-10 pl-5 pr-5 text-right rounded-xl border border-purple-300/60
                    bg-white dark:bg-gray-800 text-base font-extrabold text-purple-600
                    focus:ring-2 focus:ring-purple-400"
                       [ngModel]="_gasTrendPercentModel"
                       (ngModelChange)="gasTrendPercent = $event" placeholder="0" />
                <span class="pointer-events-none absolute left-1.5 inset-y-0 flex items-center
                   text-purple-400 font-bold text-base">−</span>
                <span class="pointer-events-none absolute right-1.5 inset-y-0 flex items-center
                   text-purple-400 font-bold text-base">%</span>
              </div>

              <div class="mt-1 flex justify-center gap-2 text-purple-500">
                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="_gasTrendPercentModel = (_gasTrendPercentModel ?? 0) - 0.5; gasTrendPercent = _gasTrendPercentModel">
                  −0.5
                </button>

                <button type="button"
                        class="inline-flex items-center justify-center h-6 leading-6 px-2
                     rounded-md border border-purple-300/60 hover:bg-purple-50
                     text-[11px] font-medium"
                        (click)="_gasTrendPercentModel = (_gasTrendPercentModel ?? 0) + 0.5; gasTrendPercent = _gasTrendPercentModel">
                  +0.5
                </button>
              </div>
            </div>
          </div>

          <!-- Trend viewer auto (plus de "VIEW_TRENDS") -->
          <div class="mt-3 p-3 rounded-xl border border-purple-300/50 bg-purple-50/20 dark:bg-white/5">
            <app-swap-gas-trend-viewer [gasTrendData]="{ '1h': -15.4, '3h': -3.1, '6h': 2.4, '24h': 6.7 }"
                                       [isLoading]="false"
                                       [hasData]="true"
                                       (applyPercentage)="null">
            </app-swap-gas-trend-viewer>
          </div>

          <!-- Live preview -->
          <div *ngIf="currentGasGwei" class="mt-3 text-xs text-green-600 font-medium">
            ✔ {{ 'CURRENT_PRICE' | translate }}: <strong>0.30965 Gwei</strong>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Create alert button -->
    <!--<button [ngClass]="{'text-xl font-extrabold tracking-wide': isArabicLang,'inactive-style' :subscriptionStatus !== 'active'}" (click)="createAlert()"
          [disabled]="isCreatingAlert"
          class="w-full py-4 rounded-xl font-medium text-white bg-gradient-to-r from-purple-500 to-indigo-600 hover:brightness-110 transition text-sm shadow-md tracking-wide">
    <ng-container *ngIf="!isCreatingAlert; else loading">
      {{ 'CREATE_ALERT' | translate }}
    </ng-container>
    <ng-template #loading>
      <svg class="animate-spin h-5 w-5 mx-auto text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
           viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </ng-template>
  </button>-->
    <!-- Actions -->
    <div class="w-full py-1 rounded-xl font-medium text-white text-sm shadow-md tracking-wide hover:brightness-110 transition bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600"
         [ngClass]="{
       'bg-white ': !isDarkMode(),
       'bg-[#1e1e2f]/70 dark:shadow-purple-900/10': isDarkMode()
     }">

      <div class="flex flex-row justify-around gap-2">
        <!-- SHARE -->
        <div class="flex-1 flex flex-col items-center cursor-pointer p-2 rounded-xl transition glow-btn" (click)="onShareClick()">
          <img src="assets/icons/newspaper-512.png" alt="Share" class="w-auto h-6" />
          <span class="text-sm  text-white bg-clip-text bg-gradient-to-l from-purple-300 via-purple-500 to-indigo-600 pl-2">
            {{ 'SHARE' | translate }}
          </span>
        </div>

        <!-- Valider -->
        <div class="flex-1 flex flex-col items-center cursor-pointer p-2 rounded-xl transition glow-btn" (click)="createAlert()">
          <img src="assets/icons/check-mark-7-512.png" alt="Valider" class="w-auto h-6 object-contain -mt-1" />
          <span class="text-sm  text-white bg-clip-text bg-gradient-to-l from-purple-300 via-purple-500 to-indigo-600 pl-2">
            {{ 'VALIDATE' | translate }}
          </span>
        </div>
      </div>

      <style>
        .optimize-icon {
          transition: transform 0.3s ease-in-out;
        }

          .optimize-icon:hover {
            animation: launch 0.4s ease-in-out;
          }

        .glow-btn:hover {
          box-shadow: 0 0 8px rgba(139, 92, 246, 0.5);
          transform: scale(1.03);
        }

        @keyframes launch {
          0% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-4px);
          }

          100% {
            transform: translateY(0);
          }
        }
      </style>
    </div>



  </div>


  <div *ngIf="selectedTab === 'gas'" class="rounded-2xl p-4 border  shadow-md transition-all hover:border-indigo-400/20 backdrop-blur-md mb-4" [ngClass]="{
  'bg-white border-indigo-500/10': !isDarkMode(),
  'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10': isDarkMode()
}">
    <br />
    <h2 [ngClass]="{
        'text-2xl font-extrabold tracking-wide': isArabicLang,
        'text-xl font-semibold': !isArabicLang
      }"
        class="mb-4">
      {{ 'CREATE_ALERT_GAS_PRICE' | translate }}
    </h2>

    <p [ngClass]="{
        'text-base font-medium tracking-wide text-gray-700': isArabicLang,
        'text-sm text-gray-600': !isArabicLang
      }"
       class="mb-2 text-justify">
      {{ 'GAS_PRICE_EXPLAIN' | translate }}
    </p>

    <!-- Formulaire: Coût du swap -->
    <div class="space-y-3">
      <label [ngClass]="{
             'text-base font-semibold tracking-wide': isArabicLang,
             'text-sm font-extrabold': !isArabicLang
           }"
             class="block text-sm font-extrabold mb-1 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600">
        {{ 'ALERT_GAS_PRICE_CONDITION' | translate }}
      </label>
      <div class="relative">
        <input type="number"
               step="0.01"
               [(ngModel)]="alert.threshold"
               class="w-full h-16 px-4 pr-24 rounded-xl border border-purple-400 focus:ring-2 focus:ring-purple-400 transition-all font-semibold text-lg
bg-white dark:bg-gray-800 text-black placeholder-gray-400 dark:placeholder-gray-500"
               [ngClass]="isDarkMode()
              ? 'bg-gray-800 placeholder-gray-500'
              : 'bg-white placeholder-gray-400'"
               placeholder="ex: 30" />

        <!-- Suffixe unité -->
        <span class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none
               text-sm text-gray-500 dark:text-gray-400">
          {{ 'GWEI' | translate }}
        </span>
      </div>

      <p [ngClass]="{
         'text-base font-medium tracking-wide text-gray-700': isArabicLang,
         'text-sm text-gray-600': !isArabicLang
       }">
        {{ 'CURRENT_PRICE' | translate }} : {{ currentGasPriceGwei | number:'1.0-2' }} Gwei
      </p>

      <button [ngClass]="{
              'text-lg font-semibold tracking-wide': isArabicLang,
              'text-sm': !isArabicLang
            }"
              class="btn-primary py-3 px-6" [disabled]="subscriptionStatus !== 'active'" (click)="createAlert()">
        {{ 'CREATE_THE_ALERT' | translate }}
      </button>
    </div>
  </div>





  <div *ngIf="subscriptionStatus === 'active'" class="max-w-xl mx-auto space-y-4">
    <div *ngIf="alerts.length > 0" class="filter-container p-4 rounded-2xl shadow mt-6 mb-4">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

        <!-- Input de recherche -->
        <input [(ngModel)]="filterText"
               (ngModelChange)="onFilterChange($event)"
               type="text"
               [placeholder]="'FILTER_BY_TOKEN' | translate"
               [ngClass]="{
               'text-base font-medium tracking-wide': isArabicLang,
               'text-sm': !isArabicLang
             }"
               class="w-full md:w-1/3 px-3 py-2 rounded-xl border"
               [disabled]="isLoading" />

        <!-- Boutons de tri et reset -->
        <div class="flex gap-2 justify-end">
          <button (click)="toggleSortOrder()"
                  [ngClass]="{
                  'text-base font-semibold tracking-wide': isArabicLang,
                  'text-sm': !isArabicLang
                }"
                  class="sort-btn px-3 py-2 rounded-xl"
                  [disabled]="isLoading">
            {{ 'SORT' | translate }}: {{ sortOrder === 'asc' ? ('ASCENDING' | translate) : ('DESCENDING' | translate) }}
          </button>

          <button (click)="resetAllAlerts()"
                  [ngClass]="{
                  'text-base font-semibold tracking-wide': isArabicLang,
                  'text-sm': !isArabicLang
                }"
                  class="reset-btn px-3 py-2 rounded-xl"
                  [disabled]="isLoading">
            {{ 'RESET_ALL_ALERTS' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isAlertsLoading && subscriptionStatus === 'active'" class="text-center text-sm text-purple-500 font-semibold my-4 animate-pulse">
    ⏳ {{ 'LOADING_ALERTS' | translate }}
  </div>

  <!-- Active Alerts List -->
  <div *ngIf="alerts.length > 0 && subscriptionStatus === 'active'">
    <h3 [ngClass]="{
      'text-xl font-extrabold tracking-wide': isArabicLang,
      'text-lg font-semibold': !isArabicLang
    }">
      {{ 'ACTIVE_ALERTS' | translate }}
    </h3>

    <div *ngFor="let alert of getDisplayedAlerts(); let i = index"
         class="alert-card flex mt-4 justify-between items-start   rounded-2xl shadow-xl mb-6 transition-all duration-300 ease-in-out bg-white  shadow-md">


      <div class="w-full">
        <!-- Token Price Alert -->
        <ng-container *ngIf="alert.alertType === 'tokenPrice'; else gasAlertBlock">
          <app-token-price-alert-viewer [alert]="castToFullAlert(alert)"
                                        [currencySymbol]="currencySymbol"
                                        [isArabicLang]="isArabicLang"
                                        [chainId]="alert.chainId"
                                        [priceMap]="priceMap"
                                        [defaultFiat]="defaultFiat"
                                        (reactivateAlert)="reactivateAlert($event)"
                                        (goToSwap)="goToSwap($event)"
                                        (removeAlert)="removeAlert(i)">
          </app-token-price-alert-viewer>
        </ng-container>

        <!-- Gas Price Alert -->
        <ng-template #gasAlertBlock>
          <app-gas-price-alert-viewer [alert]="castToFullAlert(alert)"
                                      [isArabicLang]="isArabicLang"
                                      [isLoading]="isLoading"
                                      (reactivateAlert)="reactivateAlert($event)"
                                      (goToSwap)="goToSwap($event)"
                                      (removeAlert)="removeAlert(i)">
          </app-gas-price-alert-viewer>
        </ng-template>

      </div>

    </div>



  </div>
  <div *ngIf="subscriptionStatus !== 'active'" class="mt-6">
    <h3 class="text-sm font-bold mb-2 text-center text-purple-600 dark:text-purple-300">
      {{ 'DISCOVER_SMART_ALERTS' | translate }}
    </h3>

    <div class="space-y-4 mt-6" *ngIf="mockAlerts?.length">
      <div *ngFor="let alert of mockAlerts; let i = index" class="alert-card flex mt-4 justify-between items-start   rounded-2xl shadow-xl mb-6 transition-all duration-300 ease-in-out bg-white  shadow-md">


        <div class="w-full">
          <app-token-price-alert-viewer [alert]="castToFullAlert(alert)"
                                        [alerts]="mockAlerts"
                                        [currentIndex]="i"
                                        [currencySymbol]="currencySymbol"
                                        [isArabicLang]="isArabicLang"
                                        [chainId]="alert.chainId"
                                        [priceMap]="priceMap"
                                        [defaultFiat]="defaultFiat"
                                        (reactivateAlert)="reactivateAlert($event)"
                                        (goToSwap)="goToSwap($event)"
                                        (removeAlert)="removeAlert(1)">
          </app-token-price-alert-viewer>
        </div>
      </div>
    </div>







  </div>
</div>
<div class="h-24 sm:h-28"></div> <!-- espace vide pour libérer la zone du footer -->
<!-- 🔻 Footer Fixe Mobile -->
<div class="fixed bottom-0 left-0 right-0 z-50 border-t border-indigo-300  backdrop-blur-md  p-2 shadow-inner" [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10' : 'bg-white border-indigo-500/10'">
  <div class="flex justify-around items-center gap-3 text-sm">

    <!-- 📋 Menu déroulant -->
    <div class="relative">
      <button (click)="showFooterMenu = !showFooterMenu"
              class="p-2 rounded-full border border-indigo-300 text-indigo-500  transition">
        <!-- Icône 4 barres -->
        <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2"
             viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      </button>

      <!-- Sous-menu -->
      <ul *ngIf="showFooterMenu"
          class="absolute bottom-14 left-0 w-[90vw] max-w-xs rounded-xl shadow-lg border border-white/10 backdrop-blur-md transition-all duration-300 ease-in-out"
          [ngClass]="isDarkMode() ? 'bg-gray-900/80 text-white' : 'bg-white/80 text-gray-800'">

        <li>
          <a routerLink="/alerts"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold text-purple-300">
            {{ 'CONFIGURE_ALERTS' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold text-purple-300">
            {{ 'SWAP' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/bridge"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold text-purple-300">
            {{ 'BRIDGE' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/a-propos"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold text-purple-300">
            {{ 'ABOUT' | translate }}
          </a>
        </li>
      </ul>


    </div>


    <!-- 🌐 Sélecteur Réseau harmonisé (adapté à showChainMenu) -->
    <div class="relative min-w-[130px] h-8 flex items-center">
      <button type="button"
              (click)="showChainMenu = !showChainMenu"
              class="flex items-center justify-between w-full px-2 py-1 h-8 rounded-xl text-xs font-medium border backdrop-blur-md shadow-sm transition-all duration-200"
              [ngClass]="{
    'bg-white text-gray-800 border-gray-300 hover:ring-2 hover:ring-blue-300': !isDarkMode(),
    'bg-[#1e1e2f]/70 text-white border-gray-600 hover:ring-2 hover:ring-blue-500/40': isDarkMode()
  }">
        <div class="flex items-center gap-2">
          <img *ngIf="chainInfo" [src]="chainInfo.icon" class="w-4 h-4 rounded-full shadow-sm" />
          <span class="whitespace-nowrap truncate max-w-[80px]">{{ chainInfo?.name }}</span>
        </div>
        <svg class="w-3 h-3 opacity-70" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                clip-rule="evenodd" />
        </svg>
      </button>

      <!-- Dropdown réseaux (déjà géré plus bas dans ton code avec showChainMenu) -->
    </div>




    <!-- ⚙️ Paramètres -->
    <button (click)="toggleSettings()"
            class="p-2 rounded-full hover:bg-indigo-100/30 dark:hover:bg-indigo-900/30 transition">
      <svg class="w-5 h-5" fill="none" stroke="#a3bffa" stroke-width="2" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06
                 a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09
                 a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83
                 l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09
                 a1.65 1.65 0 0 0 1.51-1z" />
      </svg>
    </button>

  </div>
</div>
<app-settings *ngIf="showSettings"
              class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg transition-all duration-300"
              [ngClass]="isDarkMode() ? 'bg-gray-900' : 'bg-white'"
              (currencyChange)="onCurrencyChanged($event)">
</app-settings>

<ul *ngIf="showChainMenu"
    class="fixed bottom-[60px] right-4 z-[9999] w-[220px] rounded-xl shadow-lg border overflow-hidden text-sm"
    [ngClass]="isDarkMode() ? 'bg-gray-900 border-gray-700 text-white' : 'bg-white border-gray-300 text-gray-800'">
  <li *ngFor="let id of [1, 137, 42161, 56]"
      (click)="changeChain(id); showChainMenu = false"
      class="flex items-center gap-2 px-4 py-3 hover:bg-purple-100 dark:hover:bg-purple-900 cursor-pointer transition">
    <img [src]="CHAIN_MAP[id].icon" class="w-5 h-5 rounded-full" />
    <span class="font-medium">{{ CHAIN_MAP[id].name }}</span>
  </li>
</ul>
<!-- Wallet-Connect Modal -->
<div *ngIf="showWcModal"
     class="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
  <div class="bg-white dark:bg-gray-800 rounded-xl p-6 w-80 text-center">
    <h2 class="text-lg font-semibold mb-4">Connect Wallet</h2>

    <!-- QR code généré à la volée -->
    <img [src]="'https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=' + encodeURIComponent(wcUri)"
         alt="QR WalletConnect" class="mx-auto mb-4" />

    <!-- Bouton d’ouverture MetaMask -->
    <a [href]="'https://metamask.app.link/wc?uri=' + encodeURIComponent(wcUri)"
       class="inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg">
      Ouvrir dans MetaMask
    </a>

    <p class="mt-4 text-xs opacity-70">
      Après approbation, revenez ici : la connexion se finalisera automatiquement.
    </p>

    <button (click)="closeWcModal()"
            class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
      ✕
    </button>
  </div>
  <!-- 🔻 Footer Fixe Mobile -->

</div>
<app-token-selector [userTokens]="userTokens"
                    [popularTokens]="popularTokens"
                    [tokenBalances]="tokenBalances"
                    [priceMap]="priceMap"
                    [show]="showTokenModal"
                    [dark]="isDarkMode()"
                    (close)="showTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="onSellTokenSelectedFromModal($event)">
</app-token-selector>


<app-token-selector [userTokens]="userTokens"
                    [popularTokens]="popularTokens"
                    [tokenBalances]="tokenBalances"
                    [priceMap]="priceMap"
                    [show]="showBuyTokenModal"
                    [dark]="isDarkMode()"
                    (close)="showBuyTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="onBuyTokenSelectedFromModal($event)">
</app-token-selector>
<style>
  ::-webkit-scrollbar {
    display: none;
  }
</style>


